import { render, staticRenderFns } from "./CBalanceTopUpTrigger.vue?vue&type=template&id=36340b78&scoped=true&"
import script from "./CBalanceTopUpTrigger.vue?vue&type=script&lang=ts&"
export * from "./CBalanceTopUpTrigger.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36340b78",
  null
  
)

export default component.exports